import axios from "axios";
import toast from "react-hot-toast";
import { PageOptions } from "../entities/interfaces/misc";

export type ApiResponse<T> = {
  message: string;
  success: boolean;
  timestamp: string;
  data: T;
  meta: PageOptions;
  pagination: boolean;
};

const Api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_HOST,
});
Api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const errorMessage =
      error?.response?.data?.message || "Something went wrong!";
    toast.error(errorMessage);
  }
);

Api.interceptors.request.use(function (config: any) {
  config.headers.set(
    "Authorization",
    `Bearer ${localStorage.getItem("token")}`
  );
  if (config.skipStoreId) return config;
  config.headers.set("x-store-id", localStorage.getItem("storeId"));
  return config;
});

export default Api;
